import { urlService } from "infra/envs";
import SocialMediaURL from "services/SocialMediaURL.service";

const clPrefix = SocialMediaURL.COLLEGELINK_PROFILE_BASE_URL;

export const transformResData = (candidates = []) => {

    return candidates.map((candidate) => {
        
        const candidateCv = candidate?.experience?.has_cv ? `${urlService.CANDIDATE_PROFILE_PATH}/${candidate?.id}#Cv` : '';
        
        return {
            id: candidate?.id,
            last_name: candidate?.personal_information?.last_name,
            first_name: candidate?.personal_information?.first_name,
            email: candidate?.contact_information?.email,
            elligible: "Yes",
            phone_number: candidate?.contact_information?.phone_number,
            linkedin_profile:
                candidate?.contact_information?.linkedin_profile || null,
            collegelink_profile_id: candidate?.contact_information
                ?.collegelink_profile_id
                ? `${clPrefix}${candidate?.contact_information?.collegelink_profile_id}`
                : null,
            cv: candidateCv,
            view: candidate?.id,
            matchedKeywords: candidate?.matchedKeywords ?? [],
        }
    });
};

export default transformResData;
